<template>

    <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="endpoint" 
        :props="props" :titles="titles" :form="form" :bus="bus" icons="1">

        <trax-ui-input type="text" icon="text_fields" placeholder="Code (e.g. WLM)"
            v-model="form.code" :error="errors.code" required="1">
        </trax-ui-input>

        <trax-ui-input type="text" icon="text_fields" placeholder="Name (e.g. Workload Management)"
            v-model="form.name" :error="errors.name" required="1">
        </trax-ui-input>

        <trax-ui-input type="text" icon="text_fields" placeholder="Slug (e.g. workload-management)"
            v-model="form.type" :error="errors.type" required="1">
        </trax-ui-input>
        
    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: {
            bus: null,
            id: null,
            toastrId: null,
            endpoint: null,
            listId: null,
        },
    
        data: function() {
            return {
                lang: lang,
                form: {
                    list_id: this.listId,
                },
                errors: {},
                props: {
                    id: { source:'id' },
                    type: { source:'type' },
                    code: { source:'code' },
                    name: { source:'name' },
                    order: { source:'order' },
                    list_id: { source:'list_id', default: this.listId },
                },
                titles: {
                    new: lang.polaris.form.new_item,
                    update: lang.polaris.form.item_update
                }
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(this.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(this.id+'-data', function(data) {
                that.form = data;
            });
        }
    }
</script>
